<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>{{ config.headline }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="map-container">
      <div #mapElement class="map-host"></div>
      <div #popUpContainer class="ol-popup">
        <div #popUpContent class="ol-popup-content"></div>
      </div>
      @if (legend.shapeEntries.length) {
        <aside
          class="map-legend"
          aria-label="Kartenlegende"
          >
          <div class="map-legend-title">Legende</div>
          <div class="map-legend-section">
            <div class="map-legend-subtitle">Status</div>
            @for (entry of legend.statusEntries; track entry) {
              <div
                class="map-legend-entry"
                >
                <span class="map-legend-colors" aria-hidden="true">
                  @for (color of entry.colors; track color) {
                    <span
                      class="map-legend-color"
                      [style.background-color]="color"
                    ></span>
                  }
                </span>
                <span>{{ entry.label }}</span>
              </div>
            }
          </div>
          <div class="map-legend-section">
            <div class="map-legend-subtitle">Sensorsymbole</div>
            @for (entry of legend.shapeEntries; track entry) {
              <div
                class="map-legend-entry"
                >
                <span
                  class="map-legend-shape"
                  [ngClass]="'map-legend-shape--' + entry.symbol"
                  aria-hidden="true"
                ></span>
                <span>{{ entry.symbolLabel }}: {{ entry.sensorLabel }}</span>
              </div>
            }
          </div>
        </aside>
      }
    </div>
  </mat-card-content>
  @if (userService.userIsAdmin) {
    <mat-card-actions>
      <button
        mat-button
        (click)="reportModuleService.openEditReportModuleForm(config.guid)"
        >
        BEARBEITEN
      </button>
      <button
        mat-button
        (click)="reportModuleService.removeModuleFormReport(config.guid)"
        >
        LÖSCHEN
      </button>
    </mat-card-actions>
  }
</mat-card>
